export default __webpack_public_path__ + "static/media/affiliate.5332d240.jpg";